"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../../../utils");
var Icon_1 = __importDefault(require("../../Icon"));
var SubMenuItem_1 = __importDefault(require("../SubMenuItem"));
var styles_1 = require("../SharedStyles/styles");
var hooks_1 = require("../hooks");
var consts_1 = require("../consts");
var UserAccount_1 = __importDefault(require("./UserAccount"));
var consts_2 = require("./consts");
var styles_2 = require("./styles");
var UserMenu = function (_a) {
    var email = _a.email, username = _a.username, basePath = _a.basePath, items = _a.items, expandedMenu = _a.expandedMenu, setExpandedMenu = _a.setExpandedMenu, profileImageUrl = _a.profileImageUrl;
    var isMenuExpanded = expandedMenu === consts_2.MENU_ID;
    var _b = (0, react_1.useState)(false), isPopupOpen = _b[0], setIsPopupOpen = _b[1];
    var _c = (0, hooks_1.useSidebarState)(), isSidebarOpen = _c.isSidebarOpen, setIsSidebarOpen = _c.setIsSidebarOpen;
    var toggleExpanded = function () {
        if (isSidebarOpen) {
            if (expandedMenu !== consts_2.MENU_ID) {
                setExpandedMenu(consts_2.MENU_ID);
                localStorage.setItem('openSubmenu', JSON.stringify(consts_2.MENU_ID));
                var customEvent = new CustomEvent(consts_1.SIDEBAR_OPENED_SUBMENU_EVENT_NAME, { detail: { openSubmenu: consts_2.MENU_ID } });
                window.dispatchEvent(customEvent);
            }
            else {
                setExpandedMenu(null);
                localStorage.setItem('openSubmenu', JSON.stringify(null));
                var customEvent = new CustomEvent(consts_1.SIDEBAR_OPENED_SUBMENU_EVENT_NAME, { detail: { openSubmenu: null } });
                window.dispatchEvent(customEvent);
            }
        }
        else {
            setIsPopupOpen(function (prev) { return !prev; });
        }
    };
    var _d = (0, react_1.useState)(false), isPathOnUserPage = _d[0], setIsPathOnUserPage = _d[1];
    (0, utils_1.useOnPathnameChange)(function () {
        if (basePath) {
            setIsPathOnUserPage(window.location.pathname.includes(basePath));
        }
    });
    var isActive = isMenuExpanded || isPopupOpen || isPathOnUserPage;
    var menuItemRef = (0, react_1.useRef)(null);
    var menuDropdownRef = (0, react_1.useRef)(null);
    var menuPopupRef = (0, react_1.useRef)(null);
    var onClickOutside = (0, react_1.useCallback)(function () {
        if (!isSidebarOpen) {
            setExpandedMenu(null);
            setIsPopupOpen(false);
        }
    }, [isSidebarOpen]);
    var onSubmenuItemClick = function () {
        setIsPopupOpen(false);
        if (window.innerWidth < 768) {
            localStorage.setItem('isSidebarOpen', JSON.stringify(false));
            setIsSidebarOpen(false);
            var customEvent = new CustomEvent(consts_1.SIDEBAR_STATE_CHANGE_EVENT_NAME, { detail: { newState: false } });
            window.dispatchEvent(customEvent);
        }
    };
    (0, utils_1.useOnClickOutside)([menuItemRef, menuDropdownRef, menuPopupRef], onClickOutside);
    var settingsMenuList = (items || []).map(function (_a) {
        var key = _a.key, label = _a.label, to = _a.to, onClick = _a.onClick;
        var dataTestId = key.replace(/\s+/g, '-').toLowerCase();
        return ((0, jsx_runtime_1.jsx)(SubMenuItem_1.default, { isOpen: isSidebarOpen, label: label, to: to, onClick: function () {
                onClick === null || onClick === void 0 ? void 0 : onClick();
                onSubmenuItemClick();
            }, testId: "submenu-".concat(dataTestId), tabIndex: isActive ? 0 : -1 }, key));
    });
    var handleKeyDown = (0, react_1.useCallback)(function (e) {
        var _a, _b;
        // If the event wasn't prevented and it's Enter or Space
        if (!e.defaultPrevented && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            toggleExpanded();
            var autoFocusId = "submenu-".concat((_b = (_a = settingsMenuList[0]) === null || _a === void 0 ? void 0 : _a.key) === null || _b === void 0 ? void 0 : _b.toString().replace(/\s+/g, '-').toLowerCase());
            if (autoFocusId && !isActive) {
                var element = document.querySelector("[data-testid=\"".concat(autoFocusId, "\"]"));
                if (element) {
                    element.focus();
                }
            }
        }
    }, [isActive]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_2.UserContainer, __assign({ ref: menuItemRef, onClick: toggleExpanded, className: (0, classnames_1.default)({ active: isActive, open: isSidebarOpen }), "data-testid": "user-container", tabIndex: 0, "aria-label": "User menu", role: "button", onKeyDown: handleKeyDown }, { children: (0, jsx_runtime_1.jsxs)(styles_2.UserInnerContainer, { children: [(0, jsx_runtime_1.jsx)(UserAccount_1.default, { isSubmenuActive: isActive, email: email, fullName: username, profileImageUrl: profileImageUrl }), (0, jsx_runtime_1.jsx)(styles_2.DropdownOpenerContainer, __assign({ "data-testid": "sidebar-usermenu-opener", className: (0, classnames_1.default)({ isMenuExpanded: isMenuExpanded }) }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "chevron-down" }) }))] }) })), (0, jsx_runtime_1.jsx)(styles_1.ExpandableListContainer, __assign({ className: (0, classnames_1.default)({ open: isMenuExpanded && isSidebarOpen }), ref: menuDropdownRef, "data-testid": "expandable-list-container" }, { children: settingsMenuList })), (0, jsx_runtime_1.jsxs)(styles_1.ClosedPopupContainer, __assign({ popupBottomPosition: consts_2.USER_POPUP_BOTTOM_MARGIN, className: (0, classnames_1.default)({ visible: isPopupOpen && !isSidebarOpen }), ref: menuPopupRef, "data-testid": "closed-popup-container" }, { children: [(username || email) && ((0, jsx_runtime_1.jsxs)(styles_2.PopupHeadContainer, { children: [(0, jsx_runtime_1.jsx)(styles_2.PopupUserName, { children: username }), (0, jsx_runtime_1.jsx)(styles_2.PopupEmail, { children: email })] })), (0, jsx_runtime_1.jsx)(styles_2.PopupHR, {}), settingsMenuList] }))] }));
};
exports.default = UserMenu;
